export enum RequisitionListSortBy {
    None = 0,
    NumAsc = 1,
    NumDesc = 2,
    MatNumAsc = 3,
    MatNumDesc = 4,
    ClientAsc = 5,
    ClientDesc = 6,
    ContactAsc = 7,
    ContactDesc = 8,
    StatusAsc = 9,
    StatusDesc = 10,
    AmountAsc = 11,
    AmountDesc = 12,
    ModDateAsc = 13,
    ModDateDesc = 14,
  }